Vue.component("ricoh-stadium", function (resolve) {
    require(['./Ricoh.vue'], resolve)
});
// Vue.component("comedy-stadium", function (resolve) {
//     require(['./Comedy.vue'], resolve)
// });
Vue.component("manchesterarena-stadium", function (resolve) {
    require(['./ManchesterArena.vue'], resolve)
});
// Vue.component("resortsworldarena-stadium", function (resolve) {
//     require(['./ResortsWorldArena.vue'], resolve)
// });
// Vue.component("windsorhall-stadium", function (resolve) {
//     require(['./WindsorHall.vue'], resolve)
// });
// Vue.component("metroradioarena-stadium", function (resolve) {
//     require(['./MetroRadioArena.vue'], resolve)
// });
// Vue.component("firstdirectarena-stadium", function (resolve) {
//     require(['./FirstDirectArena.vue'], resolve)
// });



// Interactive Seating Venue Demo
Vue.component("interativeseatingvenuedemo-stadium", function (resolve) {
    require(['./InteractiveSeatingVenueDemo.vue'], resolve)
});
Vue.component("interactive-seating-venue-east-stand-a1", function (resolve) {
    require(['./InteractiveSeatingVenueDemo/EastStandA1.vue'], resolve)
});
Vue.component("interactive-seating-venue-east-stand-a2", function (resolve) {
    require(['./InteractiveSeatingVenueDemo/EastStandA2.vue'], resolve)
});
Vue.component("interactive-seating-venue-east-stand-a3", function (resolve) {
    require(['./InteractiveSeatingVenueDemo/EastStandA3.vue'], resolve)
});
Vue.component("interactive-seating-venue-east-stand-b1", function (resolve) {
    require(['./InteractiveSeatingVenueDemo/EastStandB1.vue'], resolve)
});
Vue.component("interactive-seating-venue-east-stand-b2", function (resolve) {
    require(['./InteractiveSeatingVenueDemo/EastStandB2.vue'], resolve)
});
Vue.component("interactive-seating-venue-east-stand-b3", function (resolve) {
    require(['./InteractiveSeatingVenueDemo/EastStandB3.vue'], resolve)
});
Vue.component("interactive-seating-venue-east-stand-b4", function (resolve) {
    require(['./InteractiveSeatingVenueDemo/EastStandB4.vue'], resolve)
});
Vue.component("interactive-seating-venue-east-stand-c1", function (resolve) {
    require(['./InteractiveSeatingVenueDemo/EastStandC1.vue'], resolve)
});
Vue.component("interactive-seating-venue-east-stand-c2", function (resolve) {
    require(['./InteractiveSeatingVenueDemo/EastStandC2.vue'], resolve)
});
Vue.component("interactive-seating-venue-east-stand-c3", function (resolve) {
    require(['./InteractiveSeatingVenueDemo/EastStandC3.vue'], resolve)
});
Vue.component("interactive-seating-venue-east-stand-c4", function (resolve) {
    require(['./InteractiveSeatingVenueDemo/EastStandC4.vue'], resolve)
});
Vue.component("interactive-seating-venue-east-stand-d1", function (resolve) {
    require(['./InteractiveSeatingVenueDemo/EastStandD1.vue'], resolve)
});
Vue.component("interactive-seating-venue-east-stand-d2", function (resolve) {
    require(['./InteractiveSeatingVenueDemo/EastStandD2.vue'], resolve)
});
Vue.component("interactive-seating-venue-west-stand-n1", function (resolve) {
    require(['./InteractiveSeatingVenueDemo/WestStandN1.vue'], resolve)
});
Vue.component("interactive-seating-venue-west-stand-n2", function (resolve) {
    require(['./InteractiveSeatingVenueDemo/WestStandN2.vue'], resolve)
});
Vue.component("interactive-seating-venue-west-stand-n3", function (resolve) {
    require(['./InteractiveSeatingVenueDemo/WestStandN3.vue'], resolve)
});
Vue.component("interactive-seating-venue-west-stand-n4", function (resolve) {
    require(['./InteractiveSeatingVenueDemo/WestStandN4.vue'], resolve)
});
Vue.component("interactive-seating-venue-west-stand-s1", function (resolve) {
    require(['./InteractiveSeatingVenueDemo/WestStandS1.vue'], resolve)
});
Vue.component("interactive-seating-venue-west-stand-s2", function (resolve) {
    require(['./InteractiveSeatingVenueDemo/WestStandS2.vue'], resolve)
});
Vue.component("interactive-seating-venue-west-stand-s3", function (resolve) {
    require(['./InteractiveSeatingVenueDemo/WestStandS3.vue'], resolve)
});
Vue.component("interactive-seating-venue-west-stand-s4", function (resolve) {
    require(['./InteractiveSeatingVenueDemo/WestStandS4.vue'], resolve)
});


// Arabic - Interactive Seating Venue Demo
Vue.component("arabic-interativeseatingvenuedemo-stadium", function (resolve) {
    require(['./ArabicInteractiveSeatingVenueDemo.vue'], resolve)
});
Vue.component("arabic-interactive-seating-venue-east-stand-a1", function (resolve) {
    require(['./ArabicInteractiveSeatingVenueDemo/ArabicEastStandA1.vue'], resolve)
});
Vue.component("arabic-interactive-seating-venue-east-stand-a2", function (resolve) {
    require(['./ArabicInteractiveSeatingVenueDemo/ArabicEastStandA2.vue'], resolve)
});
Vue.component("arabic-interactive-seating-venue-east-stand-a3", function (resolve) {
    require(['./ArabicInteractiveSeatingVenueDemo/ArabicEastStandA3.vue'], resolve)
});
Vue.component("arabic-interactive-seating-venue-east-stand-b1", function (resolve) {
    require(['./ArabicInteractiveSeatingVenueDemo/ArabicEastStandB1.vue'], resolve)
});
Vue.component("arabic-interactive-seating-venue-east-stand-b2", function (resolve) {
    require(['./ArabicInteractiveSeatingVenueDemo/ArabicEastStandB2.vue'], resolve)
});
Vue.component("arabic-interactive-seating-venue-east-stand-b3", function (resolve) {
    require(['./ArabicInteractiveSeatingVenueDemo/ArabicEastStandB3.vue'], resolve)
});
Vue.component("arabic-interactive-seating-venue-east-stand-b4", function (resolve) {
    require(['./ArabicInteractiveSeatingVenueDemo/ArabicEastStandB4.vue'], resolve)
});
Vue.component("arabic-interactive-seating-venue-east-stand-c1", function (resolve) {
    require(['./ArabicInteractiveSeatingVenueDemo/ArabicEastStandC1.vue'], resolve)
});
Vue.component("arabic-interactive-seating-venue-east-stand-c2", function (resolve) {
    require(['./ArabicInteractiveSeatingVenueDemo/ArabicEastStandC2.vue'], resolve)
});
Vue.component("arabic-interactive-seating-venue-east-stand-c3", function (resolve) {
    require(['./ArabicInteractiveSeatingVenueDemo/ArabicEastStandC3.vue'], resolve)
});
Vue.component("arabic-interactive-seating-venue-east-stand-c4", function (resolve) {
    require(['./ArabicInteractiveSeatingVenueDemo/ArabicEastStandC4.vue'], resolve)
});
Vue.component("arabic-interactive-seating-venue-east-stand-d1", function (resolve) {
    require(['./ArabicInteractiveSeatingVenueDemo/ArabicEastStandD1.vue'], resolve)
});
Vue.component("arabic-interactive-seating-venue-east-stand-d2", function (resolve) {
    require(['./ArabicInteractiveSeatingVenueDemo/ArabicEastStandD2.vue'], resolve)
});
Vue.component("arabic-interactive-seating-venue-west-stand-n1", function (resolve) {
    require(['./ArabicInteractiveSeatingVenueDemo/ArabicWestStandN1.vue'], resolve)
});
Vue.component("arabic-interactive-seating-venue-west-stand-n2", function (resolve) {
    require(['./ArabicInteractiveSeatingVenueDemo/ArabicWestStandN2.vue'], resolve)
});
Vue.component("arabic-interactive-seating-venue-west-stand-n3", function (resolve) {
    require(['./ArabicInteractiveSeatingVenueDemo/ArabicWestStandN3.vue'], resolve)
});
Vue.component("arabic-interactive-seating-venue-west-stand-n4", function (resolve) {
    require(['./ArabicInteractiveSeatingVenueDemo/ArabicWestStandN4.vue'], resolve)
});
Vue.component("arabic-interactive-seating-venue-west-stand-s1", function (resolve) {
    require(['./ArabicInteractiveSeatingVenueDemo/ArabicWestStandS1.vue'], resolve)
});
Vue.component("arabic-interactive-seating-venue-west-stand-s2", function (resolve) {
    require(['./ArabicInteractiveSeatingVenueDemo/ArabicWestStandS2.vue'], resolve)
});
Vue.component("arabic-interactive-seating-venue-west-stand-s3", function (resolve) {
    require(['./ArabicInteractiveSeatingVenueDemo/ArabicWestStandS3.vue'], resolve)
});
Vue.component("arabic-interactive-seating-venue-west-stand-s4", function (resolve) {
    require(['./ArabicInteractiveSeatingVenueDemo/ArabicWestStandS4.vue'], resolve)
});



// Kendal Mountain Festival
Vue.component("kmf-brewery-arts-centre-theatre-stadium", function (resolve) {
    require(["./KendalMountainFestival/BreweryArtsCentre/Theatre.vue"], resolve)
});
Vue.component("kmf-brewery-arts-centre-theatre-block-1", function (resolve) {
    require(["./KendalMountainFestival/BreweryArtsCentre/Theatre/1.vue"], resolve)
});

Vue.component("kmf-brewery-arts-centre-screen-one-stadium", function (resolve) {
    require(["./KendalMountainFestival/BreweryArtsCentre/ScreenOne.vue"], resolve)
});
Vue.component("kmf-brewery-arts-centre-screen-one-block-1", function (resolve) {
    require(["./KendalMountainFestival/BreweryArtsCentre/ScreenOne/1.vue"], resolve)
});

Vue.component("kmf-brewery-arts-centre-screen-two-stadium", function (resolve) {
    require(["./KendalMountainFestival/BreweryArtsCentre/ScreenTwo.vue"], resolve)
});
Vue.component("kmf-brewery-arts-centre-screen-two-block-1", function (resolve) {
    require(["./KendalMountainFestival/BreweryArtsCentre/ScreenTwo/1.vue"], resolve)
});

Vue.component("kmf-brewery-arts-centre-studio-stadium", function (resolve) {
    require(["./KendalMountainFestival/BreweryArtsCentre/Studio.vue"], resolve)
});
Vue.component("kmf-brewery-arts-centre-studio-block-1", function (resolve) {
    require(["./KendalMountainFestival/BreweryArtsCentre/Studio/1.vue"], resolve)
});

Vue.component("kmf-brewery-arts-centre-maltroom-stadium", function (resolve) {
    require(["./KendalMountainFestival/BreweryArtsCentre/Maltroom.vue"], resolve)
});
Vue.component("kmf-brewery-arts-centre-maltroom-block-1", function (resolve) {
    require(["./KendalMountainFestival/BreweryArtsCentre/Maltroom/1.vue"], resolve)
});

Vue.component("kmf-the-shakespeare-centre-stadium", function (resolve) {
    require(["./KendalMountainFestival/TheShakespeareCentre.vue"], resolve)
});
Vue.component("kmf-the-shakespeare-centre-block-1", function (resolve) {
    require(["./KendalMountainFestival/TheShakespeareCentre/1.vue"], resolve)
});

Vue.component("kmf-kendal-town-hall-stadium", function (resolve) {
    require(["./KendalMountainFestival/KendalTownHall.vue"], resolve)
});
Vue.component("kmf-kendal-town-hall-gallery", function (resolve) {
    require(["./KendalMountainFestival/KendalTownHall/Gallery.vue"], resolve)
});
Vue.component("kmf-kendal-town-hall-stalls", function (resolve) {
    require(["./KendalMountainFestival/KendalTownHall/Stalls.vue"], resolve)
});

Vue.component("kmf-kendal-leisure-centre-stadium", function (resolve) {
    require(["./KendalMountainFestival/KendalLeisureCentre.vue"], resolve)
});
Vue.component("kmf-kendal-leisure-centre-block-1", function (resolve) {
    require(["./KendalMountainFestival/KendalLeisureCentre/1.vue"], resolve)
});


// Aures London - Blimp
// Vue.component("aures-london-blimp-stadium", function (resolve) {
//     require(["./AuresLondonBlimp.vue"], resolve)
// });
// Vue.component("aures-london-blimp-block", function (resolve) {
//     require(['./AuresLondonBlimp/AuresLondonBlimpBlock.vue'], resolve)
// });
// Great Balloon Race - Shuttleworth
// Vue.component("great-balloon-race-shuttleworth-stadium", function (resolve) {
//     require(["./GreatBalloonRaceShuttleworth.vue"], resolve)
// });
// Vue.component("great-balloon-race-shuttleworth-1", function (resolve) {
//     require(['./GreatBalloonRaceShuttleworth/GreatBalloonRaceShuttleworth1.vue'], resolve)
// });
// Vue.component("great-balloon-race-shuttleworth-2", function (resolve) {
//     require(['./GreatBalloonRaceShuttleworth/GreatBalloonRaceShuttleworth2.vue'], resolve)
// });
// Vue.component("great-balloon-race-shuttleworth-3", function (resolve) {
//     require(['./GreatBalloonRaceShuttleworth/GreatBalloonRaceShuttleworth3.vue'], resolve)
// });
// Vue.component("great-balloon-race-shuttleworth-4", function (resolve) {
//     require(['./GreatBalloonRaceShuttleworth/GreatBalloonRaceShuttleworth4.vue'], resolve)
// });
// Vue.component("great-balloon-race-shuttleworth-5", function (resolve) {
//     require(['./GreatBalloonRaceShuttleworth/GreatBalloonRaceShuttleworth5.vue'], resolve)
// });
// Vue.component("great-balloon-race-shuttleworth-6", function (resolve) {
//     require(['./GreatBalloonRaceShuttleworth/GreatBalloonRaceShuttleworth6.vue'], resolve)
// });
// Vue.component("great-balloon-race-shuttleworth-7", function (resolve) {
//     require(['./GreatBalloonRaceShuttleworth/GreatBalloonRaceShuttleworth7.vue'], resolve)
// });
// Vue.component("great-balloon-race-shuttleworth-vip", function (resolve) {
//     require(['./GreatBalloonRaceShuttleworth/GreatBalloonRaceShuttleworthVIP.vue'], resolve)
// });

// Great Balloon Race - Bowood House
// Vue.component("great-balloon-race-bowood-house-stadium", function (resolve) {
//     require(['./GreatBalloonRaceBowoodHouse.vue'], resolve)
// });
// Vue.component("great-balloon-race-bowood-house-block-1", function (resolve) {
//     require(['./GreatBalloonRaceBowoodHouse/Block1.vue'], resolve)
// });
// Vue.component("great-balloon-race-bowood-house-block-2", function (resolve) {
//     require(['./GreatBalloonRaceBowoodHouse/Block2.vue'], resolve)
// });
// Vue.component("great-balloon-race-bowood-house-block-3", function (resolve) {
//     require(['./GreatBalloonRaceBowoodHouse/Block3.vue'], resolve)
// });
// Vue.component("great-balloon-race-bowood-house-block-4", function (resolve) {
//     require(['./GreatBalloonRaceBowoodHouse/Block4.vue'], resolve)
// });
// Vue.component("great-balloon-race-bowood-house-premium", function (resolve) {
//     require(['./GreatBalloonRaceBowoodHouse/Premium.vue'], resolve)
// });
// Vue.component("great-balloon-race-bowood-house-vip", function (resolve) {
//     require(['./GreatBalloonRaceBowoodHouse/VIP.vue'], resolve)
// });

// Great Balloon Race - Bolesworth Castle
// Vue.component("great-balloon-race-bolesworth-castle-stadium", function (resolve) {
//     require(['./GreatBalloonRaceBolesworthCastle.vue'], resolve)
// });
// Vue.component("great-balloon-race-bolesworth-castle-area-1", function (resolve) {
//     require(['./GreatBalloonRaceBolesworthCastle/Area1.vue'], resolve)
// });
// Vue.component("great-balloon-race-bolesworth-castle-area-2", function (resolve) {
//     require(['./GreatBalloonRaceBolesworthCastle/Area2.vue'], resolve)
// });
// Vue.component("great-balloon-race-bolesworth-castle-area-3", function (resolve) {
//     require(['./GreatBalloonRaceBolesworthCastle/Area3.vue'], resolve)
// });
// Vue.component("great-balloon-race-bolesworth-castle-area-4", function (resolve) {
//     require(['./GreatBalloonRaceBolesworthCastle/Area4.vue'], resolve)
// });
// Vue.component("great-balloon-race-bolesworth-castle-area-5", function (resolve) {
//     require(['./GreatBalloonRaceBolesworthCastle/Area5.vue'], resolve)
// });
// Vue.component("great-balloon-race-bolesworth-castle-area-6", function (resolve) {
//     require(['./GreatBalloonRaceBolesworthCastle/Area6.vue'], resolve)
// });
// Vue.component("great-balloon-race-bolesworth-castle-area-7", function (resolve) {
//     require(['./GreatBalloonRaceBolesworthCastle/Area7.vue'], resolve)
// });
// Vue.component("great-balloon-race-bolesworth-castle-vip", function (resolve) {
//     require(['./GreatBalloonRaceBolesworthCastle/VIP.vue'], resolve)
// });

// Great Balloon Race - Bolesworth Castle Large
// Vue.component("great-balloon-race-bolesworth-castle-large-stadium", function (resolve) {
//     require(['./GreatBalloonRaceBolesworthCastleLarge.vue'], resolve)
// });
// Vue.component("great-balloon-race-bolesworth-castle-large-standard-1", function (resolve) {
//     require(['./GreatBalloonRaceBolesworthCastleLarge/Standard1.vue'], resolve)
// });
// Vue.component("great-balloon-race-bolesworth-castle-large-standard-2", function (resolve) {
//     require(['./GreatBalloonRaceBolesworthCastleLarge/Standard2.vue'], resolve)
// });
// Vue.component("great-balloon-race-bolesworth-castle-large-premium-1", function (resolve) {
//     require(['./GreatBalloonRaceBolesworthCastleLarge/Premium1.vue'], resolve)
// });
// Vue.component("great-balloon-race-bolesworth-castle-large-premium-2", function (resolve) {
//     require(['./GreatBalloonRaceBolesworthCastleLarge/Premium2.vue'], resolve)
// });
// Vue.component("great-balloon-race-bolesworth-castle-large-premium-3", function (resolve) {
//     require(['./GreatBalloonRaceBolesworthCastleLarge/Premium3.vue'], resolve)
// });
// Vue.component("great-balloon-race-bolesworth-castle-large-premium-4", function (resolve) {
//     require(['./GreatBalloonRaceBolesworthCastleLarge/Premium4.vue'], resolve)
// });
// Vue.component("great-balloon-race-bolesworth-castle-large-premium-5", function (resolve) {
//     require(['./GreatBalloonRaceBolesworthCastleLarge/Premium5.vue'], resolve)
// });
// Vue.component("great-balloon-race-bolesworth-castle-large-vip", function (resolve) {
//     require(['./GreatBalloonRaceBolesworthCastleLarge/VIP.vue'], resolve)
// });

// Great Balloon Race - Charlton Park
// Vue.component("great-balloon-race-charlton-park-stadium", function (resolve) {
//     require(["./GreatBalloonRaceCharltonPark.vue"], resolve)
// });
// Vue.component("great-balloon-race-charlton-park-area-2", function (resolve) {
//     require(["./GreatBalloonRaceCharltonPark/Area2.vue"], resolve)
// });
// Vue.component("great-balloon-race-charlton-park-area-1", function (resolve) {
//     require(["./GreatBalloonRaceCharltonPark/Area1.vue"], resolve)
// });
// Vue.component("great-balloon-race-charlton-park-area-3", function (resolve) {
//     require(["./GreatBalloonRaceCharltonPark/Area3.vue"], resolve)
// });
// Vue.component("great-balloon-race-charlton-park-area-4", function (resolve) {
//     require(["./GreatBalloonRaceCharltonPark/Area4.vue"], resolve)
// });
// Vue.component("great-balloon-race-charlton-park-area-5", function (resolve) {
//     require(["./GreatBalloonRaceCharltonPark/Area5.vue"], resolve)
// });
// Vue.component("great-balloon-race-charlton-park-area-6", function (resolve) {
//     require(["./GreatBalloonRaceCharltonPark/Area6.vue"], resolve)
// });
// Vue.component("great-balloon-race-charlton-park-vip", function (resolve) {
//     require(["./GreatBalloonRaceCharltonPark/VIP.vue"], resolve)
// });

// Assembly of Yahweh Campus
// Vue.component("assembly-of-yahweh-campus-stadium", function (resolve) {
//     require(['./AssemblyOfYahwehCampus.vue'], resolve)
// });
// Vue.component("assembly-of-yahweh-campus-tent-1", function (resolve) {
//     require(['./AssemblyOfYahwehCampus/Tent1.vue'], resolve)
// });
// Vue.component("assembly-of-yahweh-campus-tent-2", function (resolve) {
//     require(['./AssemblyOfYahwehCampus/Tent2.vue'], resolve)
// });
// Vue.component("assembly-of-yahweh-campus-rv-1", function (resolve) {
//     require(['./AssemblyOfYahwehCampus/RV1.vue'], resolve)
// });
// Vue.component("assembly-of-yahweh-campus-rv-2", function (resolve) {
//     require(['./AssemblyOfYahwehCampus/RV2.vue'], resolve)
// });
// Vue.component("assembly-of-yahweh-campus-rv-3", function (resolve) {
//     require(['./AssemblyOfYahwehCampus/RV3.vue'], resolve)
// });
// Vue.component("assembly-of-yahweh-campus-rv-4", function (resolve) {
//     require(['./AssemblyOfYahwehCampus/RV4.vue'], resolve)
// });

// De Valence Pavillion
// Vue.component("de-valence-pavillion-stadium", function (resolve) {
//     require(['./DeValencePavillion.vue'], resolve)
// });
// Vue.component("de-valence-pavillion-front-stall-1", function (resolve) {
//     require(['./DeValencePavillion/FrontStall1.vue'], resolve)
// });
// Vue.component("de-valence-pavillion-front-stall-2", function (resolve) {
//     require(['./DeValencePavillion/FrontStall2.vue'], resolve)
// });
// Vue.component("de-valence-pavillion-rear-stall-3", function (resolve) {
//     require(['./DeValencePavillion/RearStall3.vue'], resolve)
// });
// Vue.component("de-valence-pavillion-rear-stall-4", function (resolve) {
//     require(['./DeValencePavillion/RearStall4.vue'], resolve)
// });
// Vue.component("de-valence-pavillion-rear-side-stall-5", function (resolve) {
//     require(['./DeValencePavillion/RearSideStall5.vue'], resolve)
// });
// Vue.component("de-valence-pavillion-rear-side-stall-6", function (resolve) {
//     require(['./DeValencePavillion/RearSideStall6.vue'], resolve)
// });
// Vue.component("de-valence-pavillion-front-side-stall-7", function (resolve) {
//     require(['./DeValencePavillion/FrontSideStall7.vue'], resolve)
// });
// Vue.component("de-valence-pavillion-front-side-stall-8", function (resolve) {
//     require(['./DeValencePavillion/FrontSideStall8.vue'], resolve)
// });
// Vue.component("de-valence-pavillion-front-balcony-1", function (resolve) {
//     require(['./DeValencePavillion/FrontBalcony1.vue'], resolve)
// });
// Vue.component("de-valence-pavillion-front-balcony-2", function (resolve) {
//     require(['./DeValencePavillion/FrontBalcony2.vue'], resolve)
// });
// Vue.component("de-valence-pavillion-rear-balcony-3", function (resolve) {
//     require(['./DeValencePavillion/RearBalcony3.vue'], resolve)
// });

// Gateshead Stadium
Vue.component("gateshead-stadium", function (resolve) {
    require(['./Gateshead.vue'], resolve)
});
// Gateshead Stadium Seatmaps
Vue.component("east-stand-a1", function (resolve) {
    require(['./Gateshead/EastStandA1.vue'], resolve)
});
Vue.component("east-stand-a2", function (resolve) {
    require(['./Gateshead/EastStandA2.vue'], resolve)
});
Vue.component("east-stand-a3", function (resolve) {
    require(['./Gateshead/EastStandA3.vue'], resolve)
});
Vue.component("east-stand-b1", function (resolve) {
    require(['./Gateshead/EastStandB1.vue'], resolve)
});
Vue.component("east-stand-b2", function (resolve) {
    require(['./Gateshead/EastStandB2.vue'], resolve)
});
Vue.component("east-stand-b3", function (resolve) {
    require(['./Gateshead/EastStandB3.vue'], resolve)
});
Vue.component("east-stand-b4", function (resolve) {
    require(['./Gateshead/EastStandB4.vue'], resolve)
});
Vue.component("east-stand-c1", function (resolve) {
    require(['./Gateshead/EastStandC1.vue'], resolve)
});
Vue.component("east-stand-c2", function (resolve) {
    require(['./Gateshead/EastStandC2.vue'], resolve)
});
Vue.component("east-stand-c3", function (resolve) {
    require(['./Gateshead/EastStandC3.vue'], resolve)
});
Vue.component("east-stand-c4", function (resolve) {
    require(['./Gateshead/EastStandC4.vue'], resolve)
});
Vue.component("east-stand-d1", function (resolve) {
    require(['./Gateshead/EastStandD1.vue'], resolve)
});
Vue.component("east-stand-d2", function (resolve) {
    require(['./Gateshead/EastStandD2.vue'], resolve)
});

Vue.component("tyne-and-wear-north-stand-1", function (resolve) {
    require(['./Gateshead/TyneAndWearNorthStand1.vue'], resolve)
});
Vue.component("tyne-and-wear-north-stand-2", function (resolve) {
    require(['./Gateshead/TyneAndWearNorthStand2.vue'], resolve)
});
Vue.component("tyne-and-wear-north-stand-3", function (resolve) {
    require(['./Gateshead/TyneAndWearNorthStand3.vue'], resolve)
});
Vue.component("tyne-and-wear-north-stand-4", function (resolve) {
    require(['./Gateshead/TyneAndWearNorthStand4.vue'], resolve)
});
Vue.component("tyne-and-wear-south-stand-1", function (resolve) {
    require(['./Gateshead/TyneAndWearSouthStand1.vue'], resolve)
});
Vue.component("tyne-and-wear-south-stand-2", function (resolve) {
    require(['./Gateshead/TyneAndWearSouthStand2.vue'], resolve)
});
Vue.component("tyne-and-wear-south-stand-3", function (resolve) {
    require(['./Gateshead/TyneAndWearSouthStand3.vue'], resolve)
});
Vue.component("tyne-and-wear-south-stand-4", function (resolve) {
    require(['./Gateshead/TyneAndWearSouthStand4.vue'], resolve)
});

// Vue.component("ssehydro-stadium", function (resolve) {
//     require(['./SSEHydro.vue'], resolve)
// });
// Vue.component("rialto-stadium", function (resolve) {
//     require(['./Rialto.vue'], resolve)
// });
// Vue.component("jerry-stadium", function (resolve) {
//     require(['./Jerry.vue'], resolve)
// });
// Vue.component("realmadrid-stadium", function (resolve) {
//     require(['./RealMadrid.vue'], resolve)
// });
Vue.component("manchester-stadium", function (resolve) {
    require(['./Manchester.vue'], resolve)
});

// Vue.component("barcelona-stadium", function (resolve) {
//     require(['./Barcelona.vue'], resolve)
// });


/* Odsal Stadium - Bradford Bulls */
// Vue.component("odsal-stadium-stadium", function (resolve) {
//     require(['./OdsalStadium.vue'], resolve)
// });
// Vue.component("odsal-stadium-block-a", function (resolve) {
//     require(['./OdsalStadium/BlockA.vue'], resolve)
// });
// Vue.component("odsal-stadium-block-b", function (resolve) {
//     require(['./OdsalStadium/BlockB.vue'], resolve)
// });
// Vue.component("odsal-stadium-block-c", function (resolve) {
//     require(['./OdsalStadium/BlockC.vue'], resolve)
// });
// Vue.component("odsal-stadium-block-d", function (resolve) {
//     require(['./OdsalStadium/BlockD.vue'], resolve)
// });
// Vue.component("odsal-stadium-block-e", function (resolve) {
//     require(['./OdsalStadium/BlockE.vue'], resolve)
// });
// Vue.component("odsal-stadium-block-f", function (resolve) {
//     require(['./OdsalStadium/BlockF.vue'], resolve)
// });
// Vue.component("odsal-stadium-block-g", function (resolve) {
//     require(['./OdsalStadium/BlockG.vue'], resolve)
// });
// Vue.component("odsal-stadium-block-chairmans-suite", function (resolve) {
//     require(['./OdsalStadium/BlockChairmansSuite.vue'], resolve)
// });
// Vue.component("odsal-stadium-block-ls", function (resolve) {
//     require(['./OdsalStadium/BlockLS.vue'], resolve)
// });
// Vue.component("odsal-stadium-block-pc", function (resolve) {
//     require(['./OdsalStadium/BlockPC.vue'], resolve)
// });
// Vue.component("odsal-stadium-block-pl", function (resolve) {
//     require(['./OdsalStadium/BlockPL.vue'], resolve)
// });
// Vue.component("odsal-stadium-block-tf", function (resolve) {
//     require(['./OdsalStadium/BlockTF.vue'], resolve)
// });
// Vue.component("odsal-stadium-block-b1", function (resolve) {
//     require(['./OdsalStadium/BlockB1.vue'], resolve)
// });
// Vue.component("odsal-stadium-block-b2", function (resolve) {
//     require(['./OdsalStadium/BlockB2.vue'], resolve)
// });
// Vue.component("odsal-stadium-block-b3", function (resolve) {
//     require(['./OdsalStadium/BlockB3.vue'], resolve)
// });
// Vue.component("odsal-stadium-block-b4", function (resolve) {
//     require(['./OdsalStadium/BlockB4.vue'], resolve)
// });
// Vue.component("odsal-stadium-block-b5", function (resolve) {
//     require(['./OdsalStadium/BlockB5.vue'], resolve)
// });
// Vue.component("odsal-stadium-block-b6", function (resolve) {
//     require(['./OdsalStadium/BlockB6.vue'], resolve)
// });
// Vue.component("odsal-stadium-block-b7", function (resolve) {
//     require(['./OdsalStadium/BlockB7.vue'], resolve)
// });
// Vue.component("odsal-stadium-block-b8", function (resolve) {
//     require(['./OdsalStadium/BlockB8.vue'], resolve)
// });
// Vue.component("odsal-stadium-block-b9", function (resolve) {
//     require(['./OdsalStadium/BlockB9.vue'], resolve)
// });
// Vue.component("odsal-stadium-block-b10", function (resolve) {
//     require(['./OdsalStadium/BlockB10.vue'], resolve)
// });
// Vue.component("odsal-stadium-block-b11", function (resolve) {
//     require(['./OdsalStadium/BlockB11.vue'], resolve)
// });
// Vue.component("odsal-stadium-block-b12", function (resolve) {
//     require(['./OdsalStadium/BlockB12.vue'], resolve)
// });
// Vue.component("odsal-stadium-block-b13", function (resolve) {
//     require(['./OdsalStadium/BlockB13.vue'], resolve)
// });
// Vue.component("odsal-stadium-block-b14", function (resolve) {
//     require(['./OdsalStadium/BlockB14.vue'], resolve)
// });
// Vue.component("odsal-stadium-block-m", function (resolve) {
//     require(['./OdsalStadium/BlockM.vue'], resolve)
// });
// Vue.component("odsal-stadium-block-mf", function (resolve) {
//     require(['./OdsalStadium/BlockMF.vue'], resolve)
// });



///// ** BRADFORD ** ////

// Vue.component("bradford-stadium", function (resolve) {
//     require(['./Bradford.vue'], resolve)
// });

// Vue.component("brad-east-stand-a1", function (resolve) {
//     require(['./Bradford/EastStandA1.vue'], resolve)
// });
// Vue.component("brad-east-stand-a2", function (resolve) {
//     require(['./Bradford/EastStandA2.vue'], resolve)
// });
// Vue.component("brad-east-stand-a3", function (resolve) {
//     require(['./Bradford/EastStandA3.vue'], resolve)
// });
// Vue.component("brad-east-stand-b1", function (resolve) {
//     require(['./Bradford/EastStandB1.vue'], resolve)
// });
// Vue.component("brad-east-stand-b2", function (resolve) {
//     require(['./Bradford/EastStandB2.vue'], resolve)
// });
// Vue.component("brad-east-stand-b3", function (resolve) {
//     require(['./Bradford/EastStandB3.vue'], resolve)
// });
// Vue.component("brad-east-stand-b4", function (resolve) {
//     require(['./Bradford/EastStandB4.vue'], resolve)
// });
// Vue.component("brad-east-stand-c1", function (resolve) {
//     require(['./Bradford/EastStandC1.vue'], resolve)
// });
// Vue.component("brad-east-stand-c2", function (resolve) {
//     require(['./Bradford/EastStandC2.vue'], resolve)
// });
// Vue.component("brad-east-stand-c3", function (resolve) {
//     require(['./Bradford/EastStandC3.vue'], resolve)
// });
// Vue.component("brad-east-stand-c4", function (resolve) {
//     require(['./Bradford/EastStandC4.vue'], resolve)
// });
// Vue.component("brad-east-stand-d1", function (resolve) {
//     require(['./Bradford/EastStandD1.vue'], resolve)
// });
// Vue.component("brad-east-stand-d2", function (resolve) {
//     require(['./Bradford/EastStandD2.vue'], resolve)
// });

// Vue.component("brad-tyne-and-wear-north-stand-1", function (resolve) {
//     require(['./Bradford/TyneAndWearNorthStand1.vue'], resolve)
// });
// Vue.component("brad-tyne-and-wear-north-stand-2", function (resolve) {
//     require(['./Bradford/TyneAndWearNorthStand2.vue'], resolve)
// });
// Vue.component("brad-tyne-and-wear-north-stand-3", function (resolve) {
//     require(['./Bradford/TyneAndWearNorthStand3.vue'], resolve)
// });
// Vue.component("brad-tyne-and-wear-north-stand-4", function (resolve) {
//     require(['./Bradford/TyneAndWearNorthStand4.vue'], resolve)
// });
// Vue.component("brad-tyne-and-wear-south-stand-1", function (resolve) {
//     require(['./Bradford/TyneAndWearSouthStand1.vue'], resolve)
// });
// Vue.component("brad-tyne-and-wear-south-stand-2", function (resolve) {
//     require(['./Bradford/TyneAndWearSouthStand2.vue'], resolve)
// });
// Vue.component("brad-tyne-and-wear-south-stand-3", function (resolve) {
//     require(['./Bradford/TyneAndWearSouthStand3.vue'], resolve)
// });
// Vue.component("brad-tyne-and-wear-south-stand-4", function (resolve) {
//     require(['./Bradford/TyneAndWearSouthStand4.vue'], resolve)
// });


// Speigeltent Theatre
// Vue.component("speigeltent-standing-stadium", function (resolve) {
//     require(['./Speigeltent/SpeigeltentStanding.vue'], resolve)
// });
// Vue.component("speigeltent-theatre-seating-stadium", function (resolve) {
//     require(['./Speigeltent/SpeigeltentTheatreSeating.vue'], resolve)
// });
// Vue.component("speigeltent-theatre-seating-booths-stadium", function (resolve) {
//     require(['./Speigeltent/SpeigeltentTheatreSeatingBooths.vue'], resolve)
// });

// Vue.component("speigeltent-blocks-booths-all-seating", function (resolve) {
//     require(['./Speigeltent/Blocks/BoothsAllSeating.vue'], resolve)
// });
// Vue.component("speigeltent-blocks-booths-all-standing", function (resolve) {
//     require(['./Speigeltent/Blocks/BoothsAllStanding.vue'], resolve)
// });
// Vue.component("speigeltent-block-booths-only", function (resolve) {
//     require(['./Speigeltent/Blocks/BoothsOnly.vue'], resolve)
// });
// Vue.component("speigeltent-block-seats", function (resolve) {
//     require(['./Speigeltent/Blocks/Seats.vue'], resolve)
// });


// Scotia Bank Arena
// Vue.component("scotiabank-arena-raptors-stadium", function (resolve) {
//     require(['./scotia-bank-arena/raptors.vue'], resolve)
// });
// Vue.component("scotiabank-arena-maple-leafs-stadium", function (resolve) {
//     require(['./scotia-bank-arena/maple-leafs.vue'], resolve)
// });

// Esher Theatre
Vue.component("esher-theatre-venue1-stadium", function (resolve) {
    require(["./EsherTheatre/Venue1.vue"], resolve)
});
Vue.component("esher-theatre-venue1-block1", function (resolve) {
    require(["./EsherTheatre/Venue1/1.vue"], resolve)
});
Vue.component("esher-theatre-venue2-stadium", function (resolve) {
    require(["./EsherTheatre/Venue2.vue"], resolve)
});
Vue.component("esher-theatre-venue2-block1", function (resolve) {
    require(["./EsherTheatre/Venue2/1.vue"], resolve)
});
Vue.component("esher-theatre-venue3a-stadium", function (resolve) {
    require(["./EsherTheatre/Venue3a.vue"], resolve)
});
Vue.component("esher-theatre-venue3a-block1", function (resolve) {
    require(["./EsherTheatre/Venue3a/1.vue"], resolve)
});
Vue.component("esher-theatre-venue3b-stadium", function (resolve) {
    require(["./EsherTheatre/Venue3b.vue"], resolve)
});
Vue.component("esher-theatre-venue3b-block1", function (resolve) {
    require(["./EsherTheatre/Venue3b/1.vue"], resolve)
});
Vue.component("esher-theatre-venue4a-stadium", function (resolve) {
    require(["./EsherTheatre/Venue4a.vue"], resolve)
});
Vue.component("esher-theatre-venue4a-block1", function (resolve) {
    require(["./EsherTheatre/Venue4a/1.vue"], resolve)
});
Vue.component("esher-theatre-venue4b-stadium", function (resolve) {
    require(["./EsherTheatre/Venue4b.vue"], resolve)
});
Vue.component("esher-theatre-venue4b-block1", function (resolve) {
    require(["./EsherTheatre/Venue4b/1.vue"], resolve)
});
Vue.component("esher-theatre-venue4c-stadium", function (resolve) {
    require(["./EsherTheatre/Venue4c.vue"], resolve)
});
Vue.component("esher-theatre-venue4c-block1", function (resolve) {
    require(["./EsherTheatre/Venue4c/1.vue"], resolve)
});

// Toro
// Vue.component("toro-stadium", function (resolve) {
//     require(['./Toro.vue'], resolve)
// });
// Vue.component("toro-ayo-left", function (resolve) {
//     require(['./Toro/AYOLeft.vue'], resolve)
// });
// Vue.component("toro-mil-left", function (resolve) {
//     require(['./Toro/MILLeft.vue'], resolve)
// });
// Vue.component("toro-mil-right", function (resolve) {
//     require(['./Toro/MILRight.vue'], resolve)
// });
// Vue.component("toro-ayo-right", function (resolve) {
//     require(['./Toro/AYORight.vue'], resolve)
// });

// Toro Generic
// Vue.component("toro-generic-stadium", function (resolve) {
//     require(['./ToroGeneric.vue'], resolve)
// });
// Vue.component("toro-generic-block-1", function (resolve) {
//     require(['./ToroGeneric/Block1.vue'], resolve)
// });
// Vue.component("toro-generic-block-2", function (resolve) {
//     require(['./ToroGeneric/Block2.vue'], resolve)
// });
// Vue.component("toro-generic-block-3", function (resolve) {
//     require(['./ToroGeneric/Block3.vue'], resolve)
// });
// Vue.component("toro-generic-block-4", function (resolve) {
//     require(['./ToroGeneric/Block4.vue'], resolve)
// });

// Barrow AFC
Vue.component("barrow-afc-legacy-stadium", function (resolve) {
    require(['./BarrowAFC_LEGACY.vue'], resolve)
});
Vue.component("barrow-afc-stadium", function (resolve) {
    require(['./BarrowAFC.vue'], resolve)
});
Vue.component("barrow-afc-cross-bar-end", function (resolve) {
    require(['./BarrowAFC/CrossBarEnd.vue'], resolve)
});
Vue.component("barrow-afc-west-terrace", function (resolve) {
    require(['./BarrowAFC/WestTerrace.vue'], resolve)
});
Vue.component("barrow-afc-main-stand", function (resolve) {
    require(['./BarrowAFC/MainStand.vue'], resolve)
});
Vue.component("barrow-afc-away-end", function (resolve) {
    require(['./BarrowAFC/AwayEnd.vue'], resolve)
});
Vue.component("barrow-afc-away-corner", function (resolve) {
    require(['./BarrowAFC/AwayCorner.vue'], resolve)
});

// Harrahs Resort
Vue.component("harrahs-resort-stadium", function (resolve) {
    require(["./harrahs-resort/harrahs-resort-stadium.vue"], resolve)
});

/* ATP Stadium - Mex Tennis */
// Vue.component("atp-stadium-stadium", function (resolve) {
//     require(['./ATPStadium.vue'], resolve)
// });
// Vue.component("atp-stadium-block-a", function (resolve) {
//     require(['./ATPStadium/BlockA.vue'], resolve)
// });
// Vue.component("atp-stadium-block-b", function (resolve) {
//     require(['./ATPStadium/BlockB.vue'], resolve)
// });
// Vue.component("atp-stadium-block-c", function (resolve) {
//     require(['./ATPStadium/BlockC.vue'], resolve)
// });
// Vue.component("atp-stadium-block-d", function (resolve) {
//     require(['./ATPStadium/BlockD.vue'], resolve)
// });
// Vue.component("atp-stadium-block-e", function (resolve) {
//     require(['./ATPStadium/BlockE.vue'], resolve)
// });
// Vue.component("atp-stadium-block-f", function (resolve) {
//     require(['./ATPStadium/BlockF.vue'], resolve)
// });
// Vue.component("atp-stadium-block-g", function (resolve) {
//     require(['./ATPStadium/BlockG.vue'], resolve)
// });
// Vue.component("atp-stadium-block-chairmans-suite", function (resolve) {
//     require(['./ATPStadium/BlockChairmansSuite.vue'], resolve)
// });
// Vue.component("atp-stadium-block-ls", function (resolve) {
//     require(['./ATPStadium/BlockLS.vue'], resolve)
// });
// Vue.component("atp-stadium-block-pc", function (resolve) {
//     require(['./ATPStadium/BlockPC.vue'], resolve)
// });
// Vue.component("atp-stadium-block-pl", function (resolve) {
//     require(['./ATPStadium/BlockPL.vue'], resolve)
// });
// Vue.component("atp-stadium-block-tf", function (resolve) {
//     require(['./ATPStadium/BlockTF.vue'], resolve)
// });
// Vue.component("atp-stadium-block-b1", function (resolve) {
//     require(['./ATPStadium/BlockB1.vue'], resolve)
// });
// Vue.component("atp-stadium-block-b2", function (resolve) {
//     require(['./ATPStadium/BlockB2.vue'], resolve)
// });
// Vue.component("atp-stadium-block-b3", function (resolve) {
//     require(['./ATPStadium/BlockB3.vue'], resolve)
// });
// Vue.component("atp-stadium-block-b4", function (resolve) {
//     require(['./ATPStadium/BlockB4.vue'], resolve)
// });
// Vue.component("atp-stadium-block-b5", function (resolve) {
//     require(['./ATPStadium/BlockB5.vue'], resolve)
// });
// Vue.component("atp-stadium-block-b6", function (resolve) {
//     require(['./ATPStadium/BlockB6.vue'], resolve)
// });
// Vue.component("atp-stadium-block-b7", function (resolve) {
//     require(['./ATPStadium/BlockB7.vue'], resolve)
// });
// Vue.component("atp-stadium-block-b8", function (resolve) {
//     require(['./ATPStadium/BlockB8.vue'], resolve)
// });
// Vue.component("atp-stadium-block-b9", function (resolve) {
//     require(['./ATPStadium/BlockB9.vue'], resolve)
// });
// Vue.component("atp-stadium-block-b10", function (resolve) {
//     require(['./ATPStadium/BlockB10.vue'], resolve)
// });
// Vue.component("atp-stadium-block-b11", function (resolve) {
//     require(['./ATPStadium/BlockB11.vue'], resolve)
// });
// Vue.component("atp-stadium-block-b12", function (resolve) {
//     require(['./ATPStadium/BlockB12.vue'], resolve)
// });
// Vue.component("atp-stadium-block-b13", function (resolve) {
//     require(['./ATPStadium/BlockB13.vue'], resolve)
// });
// Vue.component("atp-stadium-block-b14", function (resolve) {
//     require(['./ATPStadium/BlockB14.vue'], resolve)
// });
// Vue.component("atp-stadium-block-m", function (resolve) {
//     require(['./ATPStadium/BlockM.vue'], resolve)
// });
// Vue.component("atp-stadium-block-mf", function (resolve) {
//     require(['./ATPStadium/BlockMF.vue'], resolve)
// });


/* Riovalli Water Park - Riovalli */
Vue.component("riovalli-water-park-stadium", function (resolve) {
    require(['./RiovalliWaterPark.vue'], resolve)
});
Vue.component("riovalli-water-park-zona-arancio", function (resolve) {
    require(['./RiovalliWaterPark/ZonaArancio.vue'], resolve)
});
Vue.component("riovalli-water-park-zona-azzurra", function (resolve) {
    require(['./RiovalliWaterPark/ZonaAzzurra.vue'], resolve)
});
Vue.component("riovalli-water-park-zona-bianca", function (resolve) {
    require(['./RiovalliWaterPark/ZonaBianca.vue'], resolve)
});
Vue.component("riovalli-water-park-zona-blu", function (resolve) {
    require(['./RiovalliWaterPark/ZonaBlu.vue'], resolve)
});
Vue.component("riovalli-water-park-zona-verde", function (resolve) {
    require(['./RiovalliWaterPark/ZonaVerde.vue'], resolve)
});



Vue.component("grand-cinema-al-hamra-stadium", function (resolve) {
    require(["./GrandCinema/AlHamra.vue"], resolve)
});



// WEBPACK FOOTER //
// ./resources/js/components/Stadiums/all.js